import { render, staticRenderFns } from "./PrivacyPolicyScreen.vue?vue&type=template&id=965a90f4&scoped=true"
import script from "./PrivacyPolicyScreen.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyScreen.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyScreen.vue?vue&type=style&index=0&id=965a90f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965a90f4",
  null
  
)

export default component.exports